const SIDEBAR_INTENT_KEY = 'workloop.sidebarIntent';

export const setSidebarIntent = (intent) => {
  try {
    if (intent) sessionStorage.setItem(SIDEBAR_INTENT_KEY, intent);
    else sessionStorage.removeItem(SIDEBAR_INTENT_KEY);
  } catch {
    // ignore
  }
};

export const consumeSidebarIntent = () => {
  try {
    const value = sessionStorage.getItem(SIDEBAR_INTENT_KEY);
    if (value) sessionStorage.removeItem(SIDEBAR_INTENT_KEY);
    return value;
  } catch {
    return null;
  }
};
